<template>
  <div id="app">
    <div id="headerCommon" v-show="headerIsShow"></div>
    <router-view/>
    <div id="footerCommon" v-show="footerIsShow"></div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      headerIsShow: true,
      footerIsShow: true
    }
  },
  created () {
    this.headerFooterShow()
  },
  methods: {
    // 头部尾部是否展示
    headerFooterShow () {
      this.headerIsShow = true
      this.footerIsShow = true
      let windowLocationHref = window.location.href
      if (windowLocationHref.indexOf('/login') >= 0 || windowLocationHref.indexOf('/email-register') >= 0 || windowLocationHref.indexOf('/register') >= 0 || windowLocationHref.indexOf('/email-update') >= 0 || windowLocationHref.indexOf('/forget') >= 0 || windowLocationHref.indexOf('/reset') >= 0 || windowLocationHref.indexOf('/welogin') >= 0) {
        this.headerIsShow = false
        this.footerIsShow = true
      }
      if (windowLocationHref.indexOf('/epidemic') >= 0) {
        this.headerIsShow = false
        this.footerIsShow = false
      }
      if (windowLocationHref.indexOf('/pdf/view') >= 0) {
        this.headerIsShow = false
        this.footerIsShow = false
      }
    }
  }
}
</script>

<style scoped>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue